module.exports = __webpack_public_path__ + "img/symbol_5.ce2f6d20.png";